import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle2, Phone } from 'lucide-react';
import { PHONE, PHONE_RAW, SITE_NAME } from '../constants/site';
import './AboutEditorialCta.css';

const tel = PHONE_RAW.replace(/[^\d+]/g, '');

const PERKS = [
  'Compare flights, hotels & packages in one call',
  'No hold music — real agents, 24/7',
  'Changes, refunds & rebooking support',
];

export default function AboutEditorialCta() {
  return (
    <div className="about-editorial-cta" role="region" aria-label="Contact our team">
      <div className="about-editorial-cta__panel">
        <div className="about-editorial-cta__main">
          <span className="about-editorial-cta__eyebrow">24/7 travel concierge</span>
          <h3 className="about-editorial-cta__title">Prefer to talk to someone?</h3>
          <ul className="about-editorial-cta__perks">
            {PERKS.map((text) => (
              <li key={text}>
                <CheckCircle2 size={18} aria-hidden />
                {text}
              </li>
            ))}
          </ul>
        </div>
        <div className="about-editorial-cta__aside">
          <a href={`tel:${tel}`} className="about-editorial-cta__call">
            <span className="about-editorial-cta__call-icon" aria-hidden>
              <Phone size={22} strokeWidth={2.5} />
            </span>
            <span className="about-editorial-cta__call-text">
              <small>Call now — it&apos;s free</small>
              <strong>{PHONE}</strong>
            </span>
          </a>
          <div className="about-editorial-cta__links">
            <Link to="/flight/search/flights" className="btn-gold about-editorial-cta__search">
              Start exploring <ArrowRight size={18} aria-hidden />
            </Link>
            <Link to="/flight/about" className="about-editorial-cta__about-link">
              More about {SITE_NAME}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
